// extracted by mini-css-extract-plugin
module.exports = {"ProjectContainer":"Project_ProjectContainer__3fbfI"};